import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  classListReducer,
  classDetailsReducer,
  classDeleteReducer,
  classCreateReducer,
  classUpdateReducer,
  classReviewCreateReducer,
  classTopRatedReducer,
  classUserListReducer,
} from './reducers/classReducers';
import {
  spaceListReducer,
  spaceUserListReducer,
  spaceDetailsReducer,
  spaceDeleteReducer,
  spaceCreateReducer,
  spaceUpdateReducer,
  spaceReviewCreateReducer,
  spaceTopRatedReducer,
} from './reducers/spaceReducers';
import { cartReducer } from './reducers/cartReducers';
import { spaceCartReducer } from './reducers/spaceCartReducers';
import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
  userListReducer,
  userDeleteReducer,
  userUpdateReducer,
} from './reducers/userReducers';
import {
  orderCreateReducer,
  orderDetailsReducer,
  orderPayReducer,
  orderDeliverReducer,
  orderListMyReducer,
  orderListReducer,
} from './reducers/orderReducers';

const reducer = combineReducers({
  classList: classListReducer,
  classUserList: classUserListReducer,
  classDetails: classDetailsReducer,
  classDelete: classDeleteReducer,
  classCreate: classCreateReducer,
  classUpdate: classUpdateReducer,
  classReviewCreate: classReviewCreateReducer,
  classTopRated: classTopRatedReducer,
  spaceList: spaceListReducer,
  spaceUserList: spaceUserListReducer,
  spaceDetails: spaceDetailsReducer,
  spaceDelete: spaceDeleteReducer,
  spaceCreate: spaceCreateReducer,
  spaceUpdate: spaceUpdateReducer,
  spaceReviewCreate: spaceReviewCreateReducer,
  spaceTopRated: spaceTopRatedReducer,
  cart: cartReducer,
  spaceCart: spaceCartReducer,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  userUpdate: userUpdateReducer,
  orderCreate: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderPay: orderPayReducer,
  orderDeliver: orderDeliverReducer,
  orderListMy: orderListMyReducer,
  orderList: orderListReducer,
});

const cartItemsFromStorage = localStorage.getItem('cartItems')
  ? JSON.parse(localStorage.getItem('cartItems'))
  : [];

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const shippingAddressFromStorage = localStorage.getItem('shippingAddress')
  ? JSON.parse(localStorage.getItem('shippingAddress'))
  : {};

const initialState = {
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: shippingAddressFromStorage,
  },
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
